import React from 'react'
import PageTitle from '../components/PageTitle'
import AddProductForm from '../components/AddProductForm'

export default () => (
  <>
    <PageTitle title="Add new products" />
    <AddProductForm />
  </>
)